import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const saveUserStatistics = (data: any) => {
  return axios.post(`${apiUrl}/statistics/save`, data);
};
